import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import { BASE_URL } from "../Constants";
import "./css/HomePage.css";

const fetchSliderData = async () => {
  const response = await axios.get(`${BASE_URL}/api/slider`);
  const { flag, slides } = response.data || {};
  if (flag && Array.isArray(slides)) {
    return slides.filter((slide) => !slide.status);
  }
  return [];
};

const HeroSliderComponent = ({ slides }) => {
  const hasExternalSlides = Array.isArray(slides);

  const {
    data: querySlides = [],
    isLoading,
    isError,
  } = useQuery("sliderData", fetchSliderData, {
    enabled: !hasExternalSlides,
    staleTime: 60000,
    cacheTime: 3600000,
  });

  const sliderData = hasExternalSlides ? slides : querySlides;
  const loading = !hasExternalSlides && isLoading;
  const error = !hasExternalSlides && isError;

  if (loading) {
    return (
      <section className="hero-slider-section" aria-label="मुख्य स्लाइडर">
        <div className="hero-slider-card">
          <div className="hero-slider-image-container hero-slider-skeleton">
            <div className="hero-slider-skeleton-pulse" />
          </div>
        </div>
      </section>
    );
  }

  if (error || !sliderData || sliderData.length === 0) {
    return null;
  }

  const renderSlideMedia = (slide, index) => {
    const imageUrl = slide.image
      ? slide.image.startsWith("http")
        ? slide.image
        : `${BASE_URL}${slide.image.startsWith("/") ? "" : "/"}${slide.image}`
      : null;

    if (!imageUrl) {
      return null;
    }

    const hasCaption = Boolean(slide.content && slide.content.trim());

    return (
      <div className="hero-slider-image-container">
        <img
          src={imageUrl}
          alt={slide.content || `गंगाद्वार मुख्य स्लाइडर ${index + 1}`}
          className="hero-slider-image"
          loading={index === 0 ? "eager" : "lazy"}
          decoding="async"
        />
        {hasCaption ? (
          <div className="hero-slider-caption-overlay">
            <div className="hero-slider-caption-content">
              <p className="hero-slider-caption-text">{slide.content}</p>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  const renderSlideContent = (slide, index) => {
    const targetUrl = slide.url ? slide.url.trim() : "";
    const isExternal =
      targetUrl.startsWith("http://") || targetUrl.startsWith("https://");

    if (isExternal) {
      return (
        <a
          href={targetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hero-slider-slide-link is-clickable"
          aria-label={slide.content || `स्लाइडर लिंक ${index + 1}`}
        >
          {renderSlideMedia(slide, index)}
        </a>
      );
    }

    if (targetUrl) {
      return (
        <Link
          to={targetUrl}
          className="hero-slider-slide-link is-clickable"
          aria-label={slide.content || `स्लाइडर लिंक ${index + 1}`}
        >
          {renderSlideMedia(slide, index)}
        </Link>
      );
    }

    return (
      <div className="hero-slider-slide-link is-static">
        {renderSlideMedia(slide, index)}
      </div>
    );
  };

  const showControls = sliderData.length > 1;

  return (
    <section className="hero-slider-section" aria-label="मुख्य स्लाइडर">
      <div className="hero-slider-card">
        <Carousel
          indicators={showControls}
          controls={showControls}
          interval={4500}
          pause="hover"
          touch={true}
          fade={false}
          className="hero-slider-carousel"
        >
          {sliderData.map((slide, index) => (
            <Carousel.Item
              key={slide.slider_id || index}
              className="hero-slider-item"
            >
              {renderSlideContent(slide, index)}
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default HeroSliderComponent;
